<div class="modal-header">
  <h4 class="modal-title">Edit Comment</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body edit-post" ngbAutofocus>
  @if (!isCommunityPost && !isVideoNote && !isHtmlComment) {
    <div class="form-group">
      <textarea type="text" name="comment" style="height: 400px" id="comment" [(ngModel)]="comment.message" class="form-control"></textarea>
    </div>
  }
  @if (isVideoNote) {
    <div class="form-group">
      <span
        role="textbox"
        aria-label="message"
        class="editable-message-span input-style"
        (keyup)="keyUpEvent($event)"
        (paste)="contentPasted()"
        (focusout)="focusOut($event)"
        contenteditable
        #messageSpan
        id="message-span"
      ></span>
    </div>
  }
  @if (comment.subject) {
    <div class="form-group edit-comment-form">
      <myp-message-input
        #editSubjectInput
        [type]="'span'"
        [backgroundColor]="appService.activeTheme == 'dark' ? '#2e2e2e' : '#e9e9e9'"
        inputID="edit-subject-input"
        (valueChanged)="postSubjectChanged($event)"
        [placeholder]="'com.start_new_post' | translate"
        [shouldDetectContent]="false"
        [includeSendButton]="false"
        [mentionSource]="false"
      ></myp-message-input>
    </div>
  }
  @if (isCommunityPost || isHtmlComment) {
    <div class="form-group edit-comment-form">
      <myp-message-input
        #editPostInput
        [type]="'span'"
        inputID="edit-post-input"
        [backgroundColor]="appService.activeTheme == 'dark' ? '#2e2e2e' : '#e9e9e9'"
        (valueChanged)="postContentChanged($event)"
        [placeholder]="'com.start_new_post' | translate"
        [shouldDetectContent]="isCommunityPost"
        [includeSendButton]="false"
        [useQuill]="isBetaComment"
        [mentionSource]="isCommunityPost ? 'community_profiles' : true"
        [mentionDataSource]="isCommunityPost ? false : collaborators"
        (contentDetected)="contentDetected($event)"
        (mentionSelected)="mentionSelected($event)"
      ></myp-message-input>
    </div>
  }

  @if (features.schedulePostsForBeta && isBetaComment && !scheduled) {
    <button class="brand-btn-reverse sm" (click)="onScheduleChange($event)">Schedule Post</button>
  }
  @if (scheduled && comment.scheduled_date) {
    <div>
      <span class="t-12">
        <fa-icon icon="times-circle" class="c-red m-r-5 pointer" (click)="onScheduleChange($event)"></fa-icon>
        <fa-icon icon="clock" class="c-official-blue"></fa-icon>
        Scheduled for
        {{ (comment.scheduled_date.toDate ? comment.scheduled_date.toDate() : comment.scheduled_date) | date: "MMM Do" }} at
        {{ (comment.scheduled_date.toDate ? comment.scheduled_date.toDate() : comment.scheduled_date) | date: "h:mma" }}
      </span>
    </div>
  }
  @if (!isVideoNote) {
    <div class="file-drop-zone" (onFileDrop)="droppedFile($event)" ng2FileDrop [uploader]="uploader" (fileOver)="fileOverBase($event)" [class.hovering]="hasBaseDropZoneOver">
      @if (files && files.length && isCommunityPost) {
        <div class="d-flex flex-wrap">
          @for (attachment of files; track attachment) {
            <div class="attachment">
              @if (workspaceService.imageFiles[attachment.extension]) {
                <img [src]="attachment.url" class="image-border" style="height: 100px" />
              }
              @if (workspaceService.audioFiles[attachment.extension]) {
                <audio id="audio_player" controls="true">
                  <source [src]="attachment.url" type="audio/wav" />
                </audio>
              }
              @if (!workspaceService.audioFiles[attachment.extension] && !workspaceService.imageFiles[attachment.extension]) {
                <span class="gothic t-18">
                  <fa-icon icon="file" class="m-r-10"></fa-icon>
                  <span>{{ attachment.filename }}</span>
                </span>
              }
              <div class="remove" (click)="removeAttachment(attachment)"><fa-icon icon="times-circle" class="c-red"></fa-icon></div>
            </div>
          }
        </div>
      }
      @if (isCommunityPost) {
        @if (comment.articles && comment.articles.length) {
          <div>
            @for (item of comment.articles; track item) {
              <div class="comment-article-attachment">
                <fa-icon icon="newspaper" class="icon"></fa-icon>
                <div>
                  <span class="bold">{{ item.article.name }}</span>
                  <br />
                  <span class="t-12 text-muted">{{ item.article.created_at_pretty }}</span>
                </div>
                <fa-icon icon="times-circle" class="close-btn" (click)="removeArticle(item)"></fa-icon>
              </div>
            }
          </div>
        }
        @if (comment.embeds && comment.embeds.length && !queued) {
          <div class="post-attachments">
            @for (embed of comment.embeds; track embed) {
              <div class="message-embed message-embed--{{ embed.type }} message-embed--{{ embed.subtype }}">
                <fa-icon icon="times-circle" class="close-btn" (click)="removeEmbed(embed)"></fa-icon>
                <iframe width="560" height="315" [src]="embed.src" frameborder="0" allowfullscreen></iframe>
              </div>
            }
          </div>
        }
        @if (comment.learn_content && comment.learn_content.length) {
          <div class="m-y-20">
            @for (item of comment.learn_content; track item) {
              @if (item.content.type == "video") {
                <div class="grid-container wider pad-10">
                  <myp-video-grid-item [showBorder]="true" [video]="item.content" [showRemoveFromPost]="true" (removeFromPostClicked)="removeLearnContent(item)"></myp-video-grid-item>
                </div>
              }
              @if (item.content.type != "video") {
                <myp-learn-list-item
                  [shouldShowButtons]="false"
                  [showRemoveFromPost]="true"
                  [item]="item.content"
                  [preventNav]="true"
                  (removeFromPostClicked)="removeLearnContent(item)"
                ></myp-learn-list-item>
              }
            }
          </div>
        }
        <div class="d-flex align-items-center">
          <span class="d-block m-r-10 t-12 bold">Attach:</span>
          <fa-icon class="circle-icon-btn m-r-5" (click)="attachFile()" [ngbTooltip]="'File'" icon="file"></fa-icon>
          <fa-icon class="circle-icon-btn m-r-5" (click)="showAttach('videos')" [ngbTooltip]="'Video'" icon="video"></fa-icon>
          <fa-icon class="circle-icon-btn m-r-5" (click)="showAttach('articles')" [ngbTooltip]="'Article'" icon="newspaper"></fa-icon>
        </div>
      }
      @if (uploadingFiles && uploadingFiles.length) {
        <div class="w-100">
          @for (file of uploadingFiles; track file) {
            <span class="text-muted t-14">{{ "general.uploading" | translate }}: {{ file.filename }} {{ file.progress }}%</span>
            <div class="post-progress-bar" [ngStyle]="{ width: (file.progress ? file.progress : 0) + '%' }"></div>
          }
        </div>
      }
    </div>
    <hr />
  }

  @if (isCommunityPost && !comment.parentID && (isBetaComment || channelsReady)) {
    <div class="form-group m-t-30">
      <div class="d-flex flex-wrap align-items-center position-relative m-t-5">
        <span class="t-12 text-muted">Channels:</span>
        @for (channel of comment.channels; track channel) {
          <span class="showcase-selected-skill">
            # {{ isBetaComment ? channel : channelTitles[channel] ? (channelTitles[channel] | localize: channel) : channel }}
            <fa-icon icon="times-circle" class="m-l-5" (click)="removeChannel(channel)"></fa-icon>
          </span>
        }
        @if ((!comment.channels || comment.channels.length < 3) && (isBetaComment || channelOptions.length)) {
          <button type="button" class="add-channel-button fa-button" aria-controls="edit-channel-list" [attr.aria-expanded]="shouldShowChannelSelector" (click)="toggleChannelSelector()">
            <fa-icon icon="plus-circle" class="c-green t-14 pointer m-l-10"></fa-icon>
            <span class="sr-only">Add a channel</span>
          </button>
        }
        <!-- Solid, not the composer's blurred panel: over this modal's form, the fields behind
             showed through. Clicking outside it or Esc closes just the list. -->
        @if (shouldShowChannelSelector) {
          <div
            class="channel-selector channel-selector--solid"
            id="edit-channel-list"
            (clickOutside)="shouldShowChannelSelector = false"
            (keydown.escape)="onChannelSelectorEscape($event)"
            tabindex="-1"
          >
            @if (!isBetaComment) {
              <div class="overflow-auto h-100">
                @for (channel of channelOptions; track channel.string_id) {
                  <button type="button" class="channel-button bold pointer t-14 p-1" (click)="addChannel(channel)">
                    <fa-icon icon="hashtag" class="c-lblue"></fa-icon>
                    {{ channel.title | localize: channel.string_id }}
                  </button>
                }
              </div>
            }
            @if (isBetaComment) {
              <div class="overflow-auto h-100">
                @for (channel of betaService.communityTags; track channel) {
                  <button type="button" class="channel-button bold pointer t-14 p-1" (click)="addChannel(channel)">
                    <fa-icon icon="hashtag" class="c-lblue"></fa-icon>
                    {{ channel.title }}
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="save()">{{ "general.save" | translate }}</button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
